
export class FnGoogleLocation {
    country: string;
    city: string;
    region: string;
    zipCode: string | number;
    siteName: string;
    siteLongitude: number;
    siteLatitude: number;
    utcOffset: number;
    addressLine1: string;
    addressLine2: string;
    // tslint:disable-next-line: variable-name
    formatted_address: string;
    countryCode: string;
    geoAddrees: string;
    geoPlaceId: string;
    dstOffset: string | number;
    timeZoneId: string;
    timeZoneName: string;
  }